var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveDashboardIconSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.993106 7.10527C0.360964 7.6742 0 8.4847 0 9.33516V16.9991C0 18.6559 1.34315 19.9991 3 19.9991H17C18.6569 19.9991 20 18.6559 20 16.9991V9.33516C20 8.4847 19.639 7.6742 19.0069 7.10527L12.0069 0.805273C10.866 -0.22155 9.13402 -0.221549 7.9931 0.805274L0.993106 7.10527ZM9 10.9991C7.89543 10.9991 7 11.8945 7 12.9991V16.9991C7 17.5514 7.44772 17.9991 8 17.9991H12C12.5523 17.9991 13 17.5514 13 16.9991V12.9991C13 11.8945 12.1046 10.9991 11 10.9991H9Z",
    fill: "#267072"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDashboardIconSidebar);
export default __webpack_public_path__ + "static/media/activeDashboardIconSidebar.eeccace760e9b675dda56466bdf4566d.svg";
export { ForwardRef as ReactComponent };